// Libs
import classNames from 'classnames/bind';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Grid2, IconButton } from '@mui/material';
// Components, Layouts, Pages
import { BaseInput } from '~/components/common';
// Others
import { IFormService } from '~/utils/interface/service';
import { DEFAULT_NUMBER_ZERO, EMPTY_STRING } from '~/utils/constants/common';
import { formatInputDecimal } from '~/utils/helper/common';
// Styles, images, icons
import styles from './LaborService.module.scss';
import { icons } from '~/assets';

type Props = {
  index: number;
  onRemoveItem: (index: number) => void;
};

const cx = classNames.bind(styles);

const MaterialService = (props: Props) => {
  //#region Destructuring Props
  const { index, onRemoveItem } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/service']);

  const {
    control,
    formState: { errors },
  } = useFormContext<IFormService>();
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Grid2
      component='div'
      id='laborServiceComponent'
      className={cx('container')}
      container
      rowSpacing={'12px'}
      columnSpacing={'12px'}
    >
      <Grid2
        size={'grow'}
        container
        rowSpacing={'12px'}
        columnSpacing={'12px'}
        className={cx(index !== DEFAULT_NUMBER_ZERO ? 'item' : EMPTY_STRING)}
      >
        <Grid2 container size={12}>
          <Grid2 size={'grow'}>
            <Controller
              name={`labors.${index}.description`}
              control={control}
              render={({ field: { value, onChange } }) => (
                <BaseInput
                  label={t('field_labor_description_label')}
                  value={value}
                  onChange={onChange}
                  errorMessage={errors?.labors?.[index]?.description?.message}
                />
              )}
            />
          </Grid2>

          <Grid2 size={'grow'}>
            <Controller
              name={`labors.${index}.hourlyCost`}
              control={control}
              render={({ field: { value, onChange } }) => (
                <BaseInput
                  label={t('field_labor_hourly_cost_label')}
                  value={value}
                  onChange={(event) => {
                    onChange(formatInputDecimal(event.target.value));
                  }}
                  errorMessage={errors?.labors?.[index]?.hourlyCost?.message}
                />
              )}
            />
          </Grid2>

          <Grid2 size={'grow'}>
            <Controller
              name={`labors.${index}.hourlyPrice`}
              control={control}
              render={({ field: { value, onChange } }) => (
                <BaseInput
                  label={t('field_labor_hourly_price_label')}
                  value={value}
                  onChange={(event) => {
                    onChange(formatInputDecimal(event.target.value));
                  }}
                  errorMessage={errors?.labors?.[index]?.hourlyPrice?.message}
                />
              )}
            />
          </Grid2>

          <Grid2 className={cx('totalField')} width={'auto'}>
            <Grid2 size='auto' className={cx('iconRemove')}>
              <IconButton className={cx('closeField')} onClick={() => onRemoveItem(index)}>
                <img src={icons.commonIconClose} alt={t('common_alt_img', { ns: 'common/base' })} />
              </IconButton>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default MaterialService;
